// eslint-disable-next-line no-restricted-imports
import { Dialog as DialogBase } from '@mui/material';

import { styled } from '../styled';

export const DialogStyled = styled(DialogBase)(({ fullScreen }) => ({
  '.MuiPaper-root': {
    borderRadius: fullScreen ? 0 : 12,
    boxShadow: '0px 24px 38px 0px rgba(45, 54, 72, 0.02)',
  },
}));
